exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--96rCzmbmPbQVkL0sypWML {\n  background: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports
exports.locals = {
	"loader": "waiting-room-sidebar--96rCzmbmPbQVkL0sypWML",
	"loader": "waiting-room-sidebar--96rCzmbmPbQVkL0sypWML"
};